/** Platform module keys (must match backend PLATFORM_MODULE_KEYS). */
export const PLATFORM_MODULE_KEYS = [
  'mes',
  'mlops',
  'quality',
  'agent',
  'files',
  'reports',
] as const;

export type PlatformModuleKey = (typeof PLATFORM_MODULE_KEYS)[number];
